<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
              class="btn btn_action btn_add"
              title="Vytvořit věkovou hranici"
              @click.prevent="createItem"
          >Vytvořit věkovou hranici</a>
        </p>
        <h1 v-translate>Věkové hranice</h1>
      </div>

      <app-table
              clickable
              deletable
              :data="items"
              :highlight-rows-on-hover="true"
              :order="params.order"
              :page-size="params.limit"
              @sort="sortItems"
              @rowClick="goToDetail"
              @deleteRow="deleteItem"
              :loading="pending"
      >
        <app-table-column first sortable attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <div v-html="row.name" />
            </strong>
          </template>
        </app-table-column>
      <app-table-column attribute="isDefault" :label="translations.isDefault">
          <template slot-scope="row">
              <app-graphic-image
                  :value="row.isDefault"
              />
          </template>
      </app-table-column>
      <app-table-column attribute="isChildDefault" :label="translations.isChildDefault">
          <template slot-scope="row">
              <app-graphic-image
                  :value="row.isChildDefault"
              />
          </template>
      </app-table-column>
        <app-table-column sortable attribute="updated" :label="translations.updated">
          <template slot-scope="row">
            <div v-html="formatDate(row._updated)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'MaturityRatings',
  detailRouteName: 'maturityRating',
})

export default {
  name: 'maturity-ratings',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin(['Věkové hranice'])],
  computed: {
    translations() {
      return {
        name: this.$gettext('Název'),
        active: this.$gettext('Aktivní'),
        updated: this.$gettext('Upraveno'),
        isDefault: this.$gettext('Výchozí'),
        isChildDefault: this.$gettext('Výchozí dětská')
      }
    },
    currentTitle() {
      return [
        this.$gettext('Věkové hranice')
      ]
    },
  },
  methods: {
    shouldRefreshAfterDelete() {
      return true
    }
  },
}
</script>
